import { Banner, Box, Typography } from '@oresundsbron/bridge-ui';
import { Trans } from 'next-i18next';
import { FC } from 'react';

export const PasswordRequirementNotice: FC<{
  title: string;
  ns: string;
  transKey: string;
  className?: string;
  listMode?: boolean;
}> = ({ title, ns, transKey, className, listMode }) => (
  <Banner className={className}>
    <Typography>{title}</Typography>
    {listMode && (
      <Box as="ul" className="mt-2 list-disc pl-6">
        <Trans i18nKey={transKey} ns={ns}>
          <Typography as="li" />
          <Typography as="li" />
          <Typography as="li" />
          <Typography as="li" />
        </Trans>
      </Box>
    )}
  </Banner>
);
